"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.join.js");

var _escape = _interopRequireDefault(require("lodash/escape"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ = {
  escape: _escape.default
};

var _default = function _default(obj) {
  var __t,
      __p = '',
      __e = _.escape,
      __j = Array.prototype.join;

  function print() {
    __p += __j.call(arguments, '');
  }

  __p += '\n<h3 class="zotero-item-title">\n	';

  if (obj.item[obj.constants.VIEW_ONLINE_URL]) {
    ;
    __p += '\n	<a href="' + __e(obj.utils.sanitizeURL(obj.item[obj.constants.VIEW_ONLINE_URL])) + '" rel="nofollow">\n		' + ((__t = obj.item.citation) == null ? '' : __t) + '\n	</a>\n	';
  } else {
    ;
    __p += '\n		' + ((__t = obj.item.citation) == null ? '' : __t) + '\n	';
  }

  ;
  __p += '\n</h3>';
  return __p;
};

exports.default = _default;